
export const PC_STATE_CONNECTED = 'connected';

export const PC_STATE_DISCONNECTED = 'disconnected';

export const PC_STATE_FAILED = 'failed';

export const PC_CON_STATE_CHANGE = 'connectionstatechange';

export const PC_ICE_CON_STATE_CHANGE = 'iceconnectionstatechange';
